let BASE_API = 'https://ais.adaptconcepts.com/october/'
let BASE_API_AIMS = 'https://aims-dev-api.adaptconcepts.com/'
let isDev = false
if (window.location && window.location.hostname &&
  (window.location.hostname.includes('adaptconcepts'))) {
  // development
  // BASE_API = 'https://ais.adaptconcepts.com/october/'
  BASE_API = 'https://www.alliedinstructional.com/october/' // temporary
  // BASE_API_AIMS = 'https://aims-staging-api.adaptconcepts.com/' // staging
  isDev = true
}
let isLive = false
if (window.location && window.location.hostname &&
  window.location.hostname.includes('prod.alliedinstructional')) {
  // live
  BASE_API = 'https://prod.alliedinstructional.com/october/'
  BASE_API_AIMS = 'https://aims-staging-api.adaptconcepts.com/'
  isLive = true
} else if (window.location && window.location.hostname &&
  (window.location.hostname.includes('www.alliedinstructional') ||
  (window.location.hostname.includes('alliedinstructional')))) {
  // live
  BASE_API = 'https://www.alliedinstructional.com/october/'
  BASE_API_AIMS = 'https://api.aims-ais.com/'
  isLive = true
}
// if (window.location && window.location.hostname &&
//   window.location.hostname.includes('aislive')) {
//   // live
//   BASE_API = 'http://aislive.adaptconcepts.com/october/'
//   isLive = true
// }
let isLocalhost = false
if (window.location && window.location.hostname &&
  (window.location.hostname.includes('localhost') || window.location.hostname.includes('127.0.0.1'))) {
  // localhost
  // BASE_API = 'http://localhost/october_ais/' // dev
  // BASE_API = 'https://ais.adaptconcepts.com/october/' // staging
  // BASE_API = 'https://prod.alliedinstructional.com/october/' // live - pre
  BASE_API = 'https://www.alliedinstructional.com/october/' // live
  // base aims
  BASE_API_AIMS = 'https://aims-dev-api.adaptconcepts.com/'
  // BASE_API_AIMS = 'https://aims-staging-api.adaptconcepts.com/'
  // BASE_API_AIMS = 'https://api.aims-ais.com/'
  isLocalhost = true
}

export const SECRET_KEY = 'AUqBpMgKo5zMdGeLRjeYHI5WLiR1iFev'

const Constants = Object.freeze({
  BASE_API,
  BASE_API_BARE: 'https://ais.com/',
  BASE_API_AIMS,
  isDev,
  isLive,
  isLocalhost,

  OptionsYesNo: {
    YES: 1,
    NO: 0,
  },

  OPTIONS_YES_NO: [{
    id: 1,
    label: 'Yes'
  }, {
    id: 0,
    label: 'No'
  }],

  Color: {
    GREEN: '#008769',
    LIGHTGREEN: '#d7e1e0',
    BEIGE: '#f4f4ec'
  },

  // Applicant (from AIMS/DataConstants)

  UploadFileType: {
    // PROVIDER: 'provider-document',
    // DIVISION: 'division-document',
    // CASELOAD: 'caseload-document',
    APPLICANT_RESUME: 'applicant-resume',
    UPLOAD_QUESTION: 'upload-question',
    UNKNOWN: 'unknown',
  },

  JobStatus: {
    DRAFT: 0,
    OPEN: 1,
    ON_HOLD: 2,
    FILLED: 3,
    CANCELED: 4,
  },

  ApplicantStatus: {
    NEW: 0,
    REVIEWED: 1,
    PRE_INTERVIEW: 9,
    INTERVIEWED: 2,
    CHECKING: 3,
    CONTRACT_SENT: 4,
    ONBOARDING: 5,
    ON_HOLD: 6,
    NOT_FIT: 7,
    NOT_QUALIFIED: 8,
  },

  ApplicantStatuses: [{
    value: 0,
    label: 'New',
  }, {
    value: 1,
    label: 'Review',
  }, {
    value: 9,
    label: 'Pre-interview',
  }, {
    value: 2,
    label: 'Interview',
  }, {
    value: 3,
    label: 'Checking References',
  }, {
    value: 4,
    label: 'Contract Sent',
  }, {
    value: 5,
    label: 'Onboarding',
  }, {
    value: 6,
    label: 'Put on Hold',
  }, {
    value: 7,
    label: 'Not a Fit',
  }, {
    value: 8,
    label: 'Not Qualified',
  }],
})

export default Constants
